import { useRef, useState } from "react";
import { Counter, FormControl, Helper, Input, InputWrapper, Label, Loader } from "./Style";
import { defaultTypes } from "./StyleType";
import { ReactComponent as IconShow } from "../../../assets/icons/olho_aberto.svg";
import { ReactComponent as IconHidden } from "../../../assets/icons/olho_fechado.svg";
import { ReactComponent as IconInfo } from "../../../assets/icons/info.svg";
import { ReactComponent as IconError } from "../../../assets/icons/erro.svg";
import { cpfMask } from '../../../helpers/Masks/CpfMask';
import { cnpjMask } from '../../../helpers/Masks/CNPJMask';
import { cepMask } from '../../../helpers/Masks/CEPMask';
import { telefoneMask } from '../../../helpers/Masks/TelefoneMask';
import { celularMask } from '../../../helpers/Masks/CelularMask';
import { numericoMask } from '../../../helpers/Masks/NumericoMask';
import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";
import TmpSpinnerCustom from "../TmpSpinnerCustom/TmpSpinnerCustom";

interface TmpInputCustomProps {
    id: string;
    label: string;
    name: string;
    type: "text" | "password";
    placeholder: string;
    value?: string;
    maxLength?: number;
    mask?: InputMaskProps;
    helperIcon?: "info" | "error";
    helperText?: string;
    error?: boolean;
    disabled?: boolean;
    mandatory?: boolean;
    ref?: any;
    showCounter?: boolean;
    capitalize?: boolean;
    enableMultipleIcon?: boolean;
    showMultiIcon?: boolean;
    //setShowMultiIcon: boolean;
    loading?: boolean;
    onChange: (e: any) => void;
    onBlur?: (e: any) => void;
}

export enum InputMaskProps {
    CPF,
    TELEFONE,
    CELULAR,
    CNPJ,
    CEP,
    NUMERICO,
    SENHA
}


export default function TmpInputCustom(props: TmpInputCustomProps) {

    // const [_value, setValue] = useState(() => {
    //     //return !!mask ? masks[mask](value) : value;
    //     return value;
    // });

    const [_keyboardFocus, setKeyboardFocus] = useState(false);
    const [_charsCount, setCharsCount] = useState(0);
    const [_inputFocus, setInputFocus] = useState(false);
    const [_inputType, setInputType] = useState(props.type);
    const refInput = useRef<HTMLInputElement>(null);
    const labelId = `${props.id}-label`;
 

    // Events
    const _handleKeyBoardEvents = (e: any) => {
        if (e.code === "Tab") {
            setKeyboardFocus(true);
            handleSetInputFocus();
        }else{
            setKeyboardFocus(false);
        }
    };

    const _handleFocus = (e: any) => {
        setInputFocus(true);
    };

    const _handleShowPassword = () => {
        if (_inputType === "password") {
            setInputType("text")
        } else {
            setInputType("password")
        }
    };

    const handleInputChange = (e: any) => {
        if (props.maxLength != null && props.maxLength > 0) {
            e.target.value = e.target.value.toString().slice(0, props.maxLength)
        }

        if (props.mask != null) {
            e.target.value = setMask(e, props.mask)
        }

        setCharsCount(e.target.value.length.toString().padStart(3, '0'))
        props.onChange(e);
    };

    const handleInputChangeBlur = (e: any) => {
        if (props.onBlur) {
            if (props.maxLength != null && props.maxLength > 0) {
                e.target.value = e.target.value.toString().slice(0, props.maxLength)
            }

            if (props.mask != null) {
                e.target.value = setMask(e, props.mask)
            }

            props.onBlur(e);
        }
        setKeyboardFocus(false);
    };

    const handleSetInputFocus = () => {
        if(refInput !== null && refInput.current !== null){
            refInput.current.focus();
        }
    }

    // Passing style props to styled component
    FormControl.defaultProps = defaultTypes;
    Label.defaultProps = defaultTypes;
    InputWrapper.defaultProps = defaultTypes;
    Input.defaultProps = defaultTypes;
    Helper.defaultProps = defaultTypes;

    return (
        <FormControl
            tabFocus={_keyboardFocus}
            focus={_inputFocus}
            onKeyUp={_handleKeyBoardEvents}
            onClick={handleSetInputFocus}
            error={props.error ? true : false}
            disabled={props.disabled ? true : false}>

            <div className="tabFocus">
                <Label htmlFor={props.id} id={labelId}>{props.label}{props.mandatory ? " *" : ""}</Label>
                <InputWrapper className="input-wrapper">
                    <Input
                        capitalize={props.capitalize ? true : false}
                        ref={refInput} 
                        id={props.id}
                        type={_inputType}
                        placeholder={props.placeholder}
                        maxLength={props.maxLength}
                        value={props.value}
                        disabled={props.disabled}
                        onChange={handleInputChange}
                        onBlur={handleInputChangeBlur}
                        onFocus={_handleFocus}
                        aria-disabled={props.disabled}
                        aria-labelledby={labelId}
                    />

                    {props.type === "password" &&
                        <TmpIconCustom
                            icon={_inputType === "password" ? <IconHidden /> : <IconShow />}
                            size="md"
                            id="show-password"
                            onClick={_handleShowPassword} />
                    }

                    {props.loading === true && (
                        <Loader>
                            <TmpSpinnerCustom />
                        </Loader>
                    )}

                </InputWrapper>
            </div>

            <Helper disabled={props.disabled ? true : false}>
                {props.helperIcon === "error" && props.error &&
                    <span className="icon error">
                        <TmpIconCustom size="sm" icon={<IconError />} />
                    </span>
                }
                {props.helperIcon === "info" &&
                    <span className="icon">
                        <TmpIconCustom size="sm" icon={<IconInfo />} />
                    </span>
                }
                {props.helperText}

                {!props.mask && props.showCounter ? (
                    <Counter>
                        {_charsCount}/{props.maxLength}
                    </Counter>
                ) : null}
            </Helper>

        </FormControl>
    );
}


function setMask(e: any, type: InputMaskProps): any {
    switch (type) {
        case InputMaskProps.CPF:
            cpfMask(e)
            break;
        case InputMaskProps.TELEFONE:
            telefoneMask(e)
            break;
        case InputMaskProps.CELULAR:
            celularMask(e)
            break;
        case InputMaskProps.CNPJ:
            cnpjMask(e)
            break;
        case InputMaskProps.CEP:
            cepMask(e)
            break;
        case InputMaskProps.NUMERICO:
            numericoMask(e)
            break;

        default:
            break;
    }

    return e.target.value;
}